import { render, staticRenderFns } from "./WhatWentWrongCard.vue?vue&type=template&id=118a03d8"
import script from "./WhatWentWrongCard.vue?vue&type=script&lang=ts"
export * from "./WhatWentWrongCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports